<div class="flex items-center justify-between space-x-4 p-4 border-t border-b">
  <!-- Left-aligned content -->
  <div class="flex items-center space-x-4">
    <div class="flex items-center border rounded-md">
      <input
        type="text"
        placeholder="Search Project"
        class="p-2 outline-none"
        (input)="onSearch($event)"
      />
      <mat-icon class="mr-4 !text-[10px] cursor-pointer">search</mat-icon>
    </div>
    <span class="p-2">Group By</span>
    <div class="flex items-center border rounded-md">
      <select class="p-2 outline-none">
        <option *ngFor="let option of groupByOptions">{{ option }}</option>
      </select>
    </div>
    <div class="flex items-center border rounded-md">
      <span class="p-2">Add Filters</span>
      <select class="p-2 outline-none">
        <option></option>
      </select>
    </div>
    <div class="flex flex-col items-center">
      <div class="flex flex-col items-center">
        <span class="p-0">Status</span>
        <select class="p-0">
          <option *ngFor="let statusOption of statusOptions">
            {{ statusOption }}
          </option>
        </select>
      </div>
    </div>
    <a class="text-blue-500 p-2 cursor-pointer" (click)="onClearAll()"
      >Clear All</a
    >
  </div>

  <!-- Right-aligned content -->
  <div class="flex items-center space-x-2">
    <!-- List View Button -->
    <button (click)="toggleView('list')">
      <mat-icon >menu</mat-icon>
    </button>
    <!-- Grid View Button -->
    <button (click)="toggleView('grid')">
      <mat-icon >apps</mat-icon>
    </button>
  </div>
</div>
